export const DATE_FORMAT = {
  yyyyMdE_jp: "yyyy年M月d日(E)",
  HHmm: "HH:mm",
};
